'use strict';

exports.__esModule = true;
exports.transformSeletedLocation = exports.transformDropdownLocation = exports.transformDropdownLanguage = exports.transformDropdownInsurer = exports.transformDropdownSpecialties = exports.transformDropdownTreatmentGroups = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transformDropdownTreatmentGroups = exports.transformDropdownTreatmentGroups = function transformDropdownTreatmentGroups() {
	var treatmentGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	var result = [];
	treatmentGroups.forEach(function (group) {
		if (group.treatments) {
			result.push({
				id: group.id,
				name: group.name,
				icon_uri: '',
				sort_order: 1,
				type: 'section-header',
				isSectionHeader: true
			});
			group.treatments.forEach(function (treatment) {
				return result.push({
					id: treatment.id,
					name: treatment.name,
					type: treatment.keyword_type,
					icon_uri: treatment.icon_uri,
					sort_order: treatment.sort_order
				});
			});
		}
	});
	return result;
};

var transformDropdownSpecialties = exports.transformDropdownSpecialties = function transformDropdownSpecialties() {
	var specialties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return [{
		name: 'Popular Specialties',
		isSectionHeader: true
	}].concat(specialties.filter(function (specialty) {
		return specialty.sort_order >= 0;
	}).map(function (specialty) {
		return (0, _extends3.default)({}, specialty, {
			icon_uri: specialty.icon_uri
		});
	}), [{
		name: 'Specialties',
		isSectionHeader: true
	}], specialties.filter(function (specialty) {
		return specialty.sort_order < 0;
	}).map(function (specialty) {
		return (0, _extends3.default)({}, specialty, {
			icon_uri: specialty.icon_uri
		});
	}));
};

var transformDropdownInsurer = exports.transformDropdownInsurer = function transformDropdownInsurer() {
	var insurers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	return insurers.map(function (insurer) {
		insurer.iconUri = (0, _doctifyUtils.getResourcePath)(insurer.icon_uri);
		return insurer;
	});
};

var transformDropdownLanguage = exports.transformDropdownLanguage = function transformDropdownLanguage() {
	var languages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return languages.filter(function (language) {
		return language.is_visible_from_website;
	});
};

var transformDropdownLocation = exports.transformDropdownLocation = function transformDropdownLocation() {
	var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return locations.map(function (location) {
		return {
			name: location.description,
			placeId: location.place_id
		};
	});
};

var transformSeletedLocation = exports.transformSeletedLocation = function transformSeletedLocation() {
	var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return {
		name: location.formatted_address,
		value: {
			lng: location.geometry.location.lng(),
			lat: location.geometry.location.lat()
		}
	};
};


// WEBPACK FOOTER //
// ./components/home-page/lib/transformers/dropdowns.js